// This file was auto-generated by prisma-generator-typescript-interfaces

export enum CandidateStatus {
  prospecting = "prospecting",
  quizSent = "quizSent",
  quizTaken = "quizTaken",
  pending = "pending",
  blacklist = "blacklist",
  shortlist = "shortlist"
}

export enum CollaboratorAccess {
  view = "view",
  edit = "edit"
}

export enum CollaboratorRoles {
  editor = "editor",
  reviewer = "reviewer",
  approver = "approver"
}

export enum DetailValueType {
  oneline = "oneline",
  multiline = "multiline",
  checkbox = "checkbox",
  radiobutton = "radiobutton"
}

export enum EmailStatus {
  pending = "pending",
  sent = "sent",
  delivered = "delivered",
  delayed = "delayed",
  opened = "opened",
  clicked = "clicked",
  bounced = "bounced",
  complained = "complained"
}

export enum JobSkillType {
  technical = "technical",
  cognitive = "cognitive"
}

export enum JobPriority {
  high = "high",
  medium = "medium",
  low = "low"
}

export enum JobStatus {
  draft = "draft",
  approved = "approved",
  active = "active",
  end = "end",
  cancelled = "cancelled"
}

export enum QuestionType {
  mcq = "mcq",
  mcqRankOption = "mcqRankOption"
}

export enum TemplateType {
  email = "email",
  jd = "jd"
}

export enum WebhookReceiver {
  user = "user",
  zapier = "zapier",
  make = "make",
  slack = "slack",
  segment = "segment"
}

export enum FolderAccessLevel {
  read = "read",
  write = "write"
}

export enum FolderUserRole {
  owner = "owner",
  editor = "editor",
  viewer = "viewer"
}

export enum FolderType {
  default = "default",
  collection = "collection"
}

export enum ProfessionalPlatform {
  linkedIn = "linkedIn",
  github = "github",
  leetcode = "leetcode",
  other = "other"
}

export enum ProductivityTool {
  leetcode = "leetcode",
  hackerRank = "hackerRank",
  codechef = "codechef",
  other = "other"
}

export enum LanguageProficiency {
  native = "native",
  fluent = "fluent",
  intermediate = "intermediate",
  basic = "basic"
}

export enum NationalIdentifier {
  passport = "passport",
  nationalId = "nationalId",
  drivingLicense = "drivingLicense",
  other = "other"
}

export enum QuizStatus {
  clicked = "clicked",
  login = "login",
  inprogress = "inprogress",
  completed = "completed",
  expired = "expired"
}

export enum TaxonomyTags {
  comprehension = "comprehension",
  application = "application",
  analysis = "analysis",
  synthesis = "synthesis",
  evaluation = "evaluation"
}

export enum UserRoles {
  owner = "owner",
  member = "member"
}

export enum WorkspacePlans {
  kickstart = "kickstart",
  pro = "pro",
  business = "business",
  enterprise = "enterprise"
}

export enum PricingPlanInterval {
  day = "day",
  week = "week",
  month = "month",
  year = "year"
}

export enum PricingType {
  oneTime = "oneTime",
  recurring = "recurring"
}

export enum SubscriptionStatus {
  trialing = "trialing",
  active = "active",
  canceled = "canceled",
  incomplete = "incomplete",
  incompleteExpired = "incompleteExpired",
  pastDue = "pastDue",
  unpaid = "unpaid"
}

export enum PayoutStatus {
  pending = "pending",
  processing = "processing",
  completed = "completed",
  failed = "failed"
}

export enum PayoutType {
  leads = "leads",
  sales = "sales",
  clicks = "clicks",
  custom = "custom"
}

export enum ProgramType {
  affiliate = "affiliate",
  referral = "referral"
}

export enum CommissionType {
  percentage = "percentage",
  flat = "flat"
}

export enum ProgramEnrollmentStatus {
  approved = "approved",
  pending = "pending",
  rejected = "rejected",
  banned = "banned",
  invited = "invited",
  declined = "declined"
}

export enum CommissionInterval {
  month = "month",
  year = "year"
}

export enum ProgramResourceType {
  logo = "logo",
  files = "files"
}

export enum PartnerStatus {
  default = "default",
  verified = "verified",
  featured = "featured"
}

export enum PartnerRole {
  owner = "owner",
  member = "member"
}

export enum InvoiceStatus {
  processing = "processing",
  completed = "completed",
  failed = "failed"
}

export enum SaleStatus {
  pending = "pending",
  processed = "processed",
  paid = "paid",
  refunded = "refunded",
  duplicate = "duplicate",
  fraud = "fraud"
}

export enum CommissionStatus {
  pending = "pending",
  processed = "processed",
  paid = "paid",
  refunded = "refunded",
  duplicate = "duplicate",
  fraud = "fraud"
}

export enum EventType {
  click = "click",
  lead = "lead",
  sale = "sale"
}

export enum PaymentProvider {
  stripe = "stripe",
  chargebee = "chargebee",
  razorpay = "razorpay"
}

export enum PartnerProfileType {
  individual = "individual",
  company = "company"
}

export interface Candidate {
  id: string;
  firstName: string;
  lastName: string | null;
  email: string | null;
  phone: string | null;
  nationality: string | null;
  createdAt: Date;
  updatedAt: Date | null;
  deletedAt: Date | null;
  summary: string | null;
}

export interface CandidateJobProspect {
  id: string;
  userId: string;
  candidateId: string;
  teamId: string;
  channel: string;
  createdAt: Date;
  updatedAt: Date | null;
  deletedAt: Date | null;
}

export interface CandidateJob {
  candidateId: string;
  jobId: string;
  joinedAt: Date;
  deletedAt: Date | null;
  candidateStatus: string;
}

export interface CandidateUsers {
  candidateId: string;
  userId: string;
  joinedAt: Date;
}

export interface CandidateFile {
  id: string;
  candidateId: string;
  quizId: string | null;
  fileType: string;
  fileUrl: string;
  uploadedAt: Date;
  fileMetadata: JsonValue | null;
}

export interface CandidateProctoringReport {
  id: string;
  candidateId: string;
  jobId: string;
  observation: string;
  evidence: string;
  createdAt: Date;
  updatedAt: Date | null;
  deletedAt: Date | null;
}

export interface CandidateJobScreening {
  id: string;
  candidateId: string;
  jobId: string;
  detailsId: string;
  detailsValue: string;
  createdAt: Date;
  updatedAt: Date | null;
  deletedAt: Date | null;
}

export interface CandidateJobApplication {
  id: string;
  candidateId: string;
  jobId: string;
  settingsId: string;
  settingsValue: string;
  createdAt: Date;
  updatedAt: Date | null;
  deletedAt: Date | null;
}

export interface CandidateJobScreeningApplication {
  id: string;
  candidateId: string;
  jobId: string;
  settingsId: string;
  settingsValue: string;
  createdAt: Date;
  updatedAt: Date | null;
  deletedAt: Date | null;
}

export interface CandidateQuizDetailReport {
  id: string;
  candidateId: string;
  jobId: string;
  quizId: string;
  createdAt: Date;
  updatedAt: Date | null;
  deletedAt: Date | null;
}

export interface CandidateQuizReport {
  id: string;
  candidateId: string;
  jobId: string;
  jdMatch: number;
  rating: number;
  quizScore: number;
  videoResume: string;
  createdAt: Date;
  updatedAt: Date | null;
  deletedAt: Date | null;
}

export interface CandidateRatingsReport {
  id: string;
  commentedBy: string;
  candidateId: string;
  jobId: string;
  comments: number;
  createdAt: Date;
  updatedAt: Date | null;
  deletedAt: Date | null;
}

export interface CandidateSkillReport {
  id: string;
  candidateId: string;
  jobId: string;
  quizId: string;
  jdMatch: number;
  jobSkillId: string;
  feedback: JsonValue;
  createdAt: Date;
  updatedAt: Date | null;
  deletedAt: Date | null;
}

export interface CandidateTaxonomyReport {
  id: string;
  candidateId: string;
  jobId: string;
  quizId: string;
  taxonomy: string;
  feedback: JsonValue;
  score: number;
  createdAt: Date;
  updatedAt: Date | null;
}

export interface CandidateContactDetail {
  id: string;
  candidateId: string;
  addressLine1: string | null;
  addressLine2: string | null;
  city: string | null;
  state: string | null;
  postalCode: string | null;
  country: string | null;
  website: string | null;
  linkedinUrl: string | null;
}

export interface CandidateEducation {
  id: string;
  candidateId: string;
  institution: string;
  degree: string | null;
  field: string | null;
  startDate: Date | null;
  endDate: Date | null;
  description: string | null;
  location: string | null;
}

export interface CandidateWorkExperience {
  id: string;
  candidateId: string;
  title: string;
  company: string;
  startDate: Date;
  endDate: Date | null;
  description: string | null;
  location: string | null;
}

export interface CandidateInternship {
  id: string;
  candidateId: string;
  title: string;
  company: string;
  startDate: Date;
  endDate: Date | null;
  description: string | null;
  location: string | null;
}

export interface CandidateSocialCause {
  id: string;
  candidateId: string;
  title: string;
  organization: string;
  causeArea: string | null;
  description: string | null;
  startDate: Date;
  endDate: Date | null;
  location: string | null;
}

export interface CandidateProject {
  id: string;
  candidateId: string;
  title: string;
  description: string | null;
  url: string | null;
  startDate: Date | null;
  endDate: Date | null;
}

export interface CandidateCertification {
  id: string;
  candidateId: string;
  name: string;
  issuingOrg: string | null;
  issueDate: Date | null;
  expirationDate: Date | null;
  credentialId: string | null;
  credentialUrl: string | null;
}

export interface CandidateSkill {
  id: string;
  candidateId: string;
  name: string;
  proficiency: number | null;
}

export interface CandidateCommunication {
  id: string;
  candidateId: string;
  verbalCommunication: number | null;
  writtenCommunication: number | null;
  interpersonalSkills: number | null;
  additionalNotes: string | null;
}

export interface CandidateLanguage {
  id: string;
  candidateId: string;
  languageName: string;
  reading: string;
  writing: string;
  listening: string;
  speaking: string;
}

export interface CandidateNationalIdentifier {
  id: string;
  candidateId: string;
  identifierNumber: string;
  country: string | null;
  issueDate: Date | null;
  expiryDate: Date | null;
  description: string | null;
  type: string;
}

export interface CandidateCandidateReference {
  id: string;
  candidateId: string;
  name: string;
  relationship: string | null;
  email: string | null;
  phone: string | null;
}

export interface CandidateOnlineProfile {
  id: string;
  candidateId: string;
  profileUrl: string;
  scrapedData: JsonValue | null;
  scrapedAt: Date | null;
  platform: string;
}

export interface CandidateProductivityData {
  id: string;
  candidateId: string;
  data: JsonValue | null;
  scrapedAt: Date | null;
  tool: string;
}

export interface Dashboard {
  id: string;
  linkId: string | null;
  teamId: string | null;
  userId: string | null;
  doIndex: boolean;
  password: string | null;
  showConversions: boolean;
  createdAt: Date;
  updatedAt: Date | null;
}

export interface Department {
  id: string;
  userId: string;
  name: string;
  createdAt: Date;
  updatedAt: Date | null;
  deletedAt: Date | null;
  teamId: string;
}

export interface Email {
  id: string;
  jobId: string;
  teamId: string;
  from: string;
  subject: string;
  to: string;
  sentAt: Date;
  updatedAt: Date | null;
  status: string;
}

export interface SentEmail {
  id: string;
  type: string;
  createdAt: Date;
  teamId: string | null;
}

export interface EmailBlacklist {
  id: string;
}

export interface CollaboratorAccessEnum {
  value: string;
}

export interface CollaboratorRolesEnum {
  value: string;
}

export interface DetailValueTypeEnum {
  value: string;
}

export interface EmailStatusEnum {
  value: string;
}

export interface JobPriorityEnum {
  value: string;
}

export interface JobStatusEnum {
  value: string;
}

export interface JobSkillTypeEnum {
  value: string;
}

export interface QuestionTypeEnum {
  value: string;
}

export interface TemplateTypeEnum {
  value: string;
}

export interface CandidateStatusEnum {
  value: string;
}

export interface WebhookReceiverEnum {
  value: string;
}

export interface FolderTypeEnum {
  value: string;
}

export interface FolderAccessLevelEnum {
  value: string;
}

export interface FolderUserRoleEnum {
  value: string;
}

export interface ProfessionalPlatformEnum {
  value: string;
}

export interface ProductivityToolEnum {
  value: string;
}

export interface LanguageProficiencyEnum {
  value: string;
}

export interface NationalIdentifierEnum {
  value: string;
}

export interface QuizStatusEnum {
  value: string;
}

export interface TaxonomyTagsEnum {
  value: string;
}

export interface Folder {
  id: string;
  name: string;
  teamId: string;
  createdAt: Date;
  updatedAt: Date | null;
  type: string;
  accessLevel: string | null;
}

export interface FolderUser {
  id: string;
  folderId: string;
  userId: string;
  createdAt: Date;
  updatedAt: Date | null;
  role: string | null;
}

export interface FolderAccessRequest {
  id: string;
  folderId: string;
  userId: string;
  createdAt: Date;
}

export interface CandidateGithubAnalysis {
  id: string;
  candidateId: string;
  githubUrl: string;
  createdAt: Date;
  updatedAt: Date | null;
  username: string | null;
  userSince: Date | null;
  avatarUrl: string | null;
  bio: string | null;
  location: string | null;
  company: string | null;
  blog: string | null;
  publicRepos: number | null;
  followers: number | null;
  following: number | null;
  technicalSkills: JsonValue | null;
  topLanguages: JsonValue | null;
  contributionActivity: JsonValue | null;
  qualitativeAssessment: JsonValue | null;
  repositoryCount: number | null;
  ownedRepositories: number | null;
  forkedRepositories: number | null;
  starredRepositoryCount: number | null;
  codeQualityScore: number | null;
  testCoverageAverage: number | null;
  documentationQuality: number | null;
  overallScore: number | null;
  strengthAreas: string[];
  improvementAreas: string[];
  topRepositories: JsonValue | null;
}

export interface CandidateGithubRepository {
  id: string;
  analysisId: string;
  name: string;
  fullName: string;
  description: string | null;
  isPrivate: boolean;
  isArchived: boolean;
  isFork: boolean;
  url: string;
  createdAt: Date;
  updatedAt: Date;
  pushedAt: Date | null;
  language: string | null;
  size: number | null;
  stargazersCount: number | null;
  watchersCount: number | null;
  forksCount: number | null;
  openIssuesCount: number | null;
  topics: string[];
  linesOfCode: number | null;
  codeQuality: number | null;
  hasTests: boolean | null;
  testCoverage: number | null;
  hasDocumentation: boolean | null;
  ownerContributions: number | null;
  contributorsCount: number | null;
}

export interface Integration {
  id: string;
  userId: string | null;
  name: string;
  createdAt: Date;
  updatedAt: Date | null;
  teamId: string;
  slug: string;
  description: string | null;
  readme: string | null;
  developer: string;
  website: string;
  logo: string | null;
  screenshots: JsonValue | null;
  verified: boolean;
  installUrl: string | null;
  guideUrl: string | null;
  comingSoon: boolean;
  category: string | null;
}

export interface InstalledIntegration {
  id: string;
  userId: string;
  integrationId: string;
  teamId: string;
  createdAt: Date;
  updatedAt: Date | null;
  credentials: JsonValue | null;
}

export interface JobAdditionalDetails {
  id: string;
  jobId: string;
  detailKey: string;
  detailValueType: string;
  detailValueOptions: JsonValue;
  isRequired: boolean;
  isBuiltin: boolean;
  createdAt: Date;
  updatedAt: Date | null;
  deletedAt: Date | null;
}

export interface JobCollaborators {
  id: string;
  userId: string;
  jobId: string;
  role: string;
  access: string;
  createdAt: Date;
  updatedAt: Date | null;
  deletedAt: Date | null;
}

export interface JobSettings {
  id: string;
  jobId: string;
  settingsKey: string;
  settingsValue: string;
  isRequired: boolean;
  createdAt: Date;
  updatedAt: Date | null;
  deletedAt: Date | null;
}

export interface JobSkills {
  id: string;
  jobId: string;
  skillName: string;
  subSkills: JsonValue;
  skillType: string;
  skillWeightage: number;
  taxonomyWeightage: JsonValue;
  priority: number;
  createdAt: Date;
  updatedAt: Date | null;
  deletedAt: Date | null;
}

export interface Job {
  id: string;
  title: string;
  key: string;
  url: string;
  comments: string | null;
  archived: boolean;
  description: string;
  priority: string;
  experienceStart: number;
  experienceEnd: number;
  positions: number;
  descriptionPath: string;
  campaignStart: Date | null;
  campaignEnd: Date | null;
  userId: string;
  createdAt: Date;
  updatedAt: Date | null;
  deletedAt: Date | null;
  externalId: string | null;
  tenantId: string | null;
  departmentId: string | null;
  teamId: string;
  status: string;
  folderId: string | null;
}

export interface JobLinks {
  jobId: string;
  linkId: string;
  createdAt: Date;
  updatedAt: Date | null;
  deletedAt: Date | null;
}

export interface JobWebhook {
  jobId: string;
  webhookId: string;
}

export interface Link {
  id: string;
  domain: string;
  key: string;
  url: string;
  shortLink: string;
  archived: boolean;
  expiresAt: Date | null;
  expiredUrl: string | null;
  password: string | null;
  trackConversion: boolean;
  proxy: boolean;
  title: string | null;
  description: string | null;
  image: string | null;
  video: string | null;
  utmSource: string | null;
  utmMedium: string | null;
  utmCampaign: string | null;
  utmTerm: string | null;
  utmContent: string | null;
  rewrite: boolean;
  doIndex: boolean;
  ios: string | null;
  android: string | null;
  geo: JsonValue | null;
  userId: string | null;
  teamId: string | null;
  programId: string | null;
  folderId: string | null;
  externalId: string | null;
  tenantId: string | null;
  publicStats: boolean;
  clicks: number;
  lastClicked: Date | null;
  leads: number;
  sales: number;
  saleAmount: number;
  createdAt: Date;
  updatedAt: Date | null;
  testVariants: JsonValue | null;
  testStartedAt: Date | null;
  testCompletedAt: Date | null;
  comments: string | null;
  partnerId: string | null;
}

export interface OAuthApp {
  id: string;
  integrationId: string;
  clientId: string;
  hashedClientSecret: string;
  partialClientSecret: string;
  redirectUris: JsonValue;
  pkce: boolean;
}

export interface OAuthCode {
  id: string;
  clientId: string;
  userId: string;
  teamId: string;
  code: string;
  scopes: string | null;
  redirectUri: string;
  codeChallenge: string | null;
  codeChallengeMethod: string | null;
  expiresAt: Date;
  createdAt: Date;
}

export interface OAuthRefreshToken {
  id: string;
  installationId: string;
  accessTokenId: string;
  hashedRefreshToken: string;
  expiresAt: Date;
  createdAt: Date;
}

export interface QuizLibrary {
  id: string;
  skillName: string;
  skillLevel: number;
  question: string;
  taxonomyTags: JsonValue;
  asset: string;
  skillTagsA: JsonValue;
  skillTagsB: JsonValue;
  skillTagsC: JsonValue;
  skillTagsD: JsonValue;
  choiceA: string;
  choiceB: string;
  choiceC: string;
  choiceD: string;
  relevanceA: number;
  relevanceB: number;
  relevanceC: number;
  relevanceD: number;
  scoreA: number;
  scoreB: number;
  scoreC: number;
  scoreD: number;
  experienceLevel: string;
  experienceAMin: number;
  experienceAMax: number;
  experienceBMin: number;
  experienceBMax: number;
  experienceCMin: number;
  experienceCMax: number;
  experienceDMin: number;
  experienceDMax: number;
  difficultyLevel: number;
  readingTimeSeconds: number;
  version: number;
  gpt: number;
  createdAt: Date;
  updatedAt: Date | null;
  deletedAt: Date | null;
}

export interface JobQuizLibraryMapping {
  id: string;
  libraryId: string;
  jobId: string;
  usage: number;
  createdAt: Date;
  updatedAt: Date | null;
  deletedAt: Date | null;
}

export interface QuizLibraryUsage {
  id: string;
  libraryId: string;
  usage: number;
  createdAt: Date;
  updatedAt: Date | null;
  deletedAt: Date | null;
}

export interface CandidateQuiz {
  id: string;
  candidateId: string;
  quizId: string;
  status: string;
  startedAt: Date;
  completedAt: Date | null;
  currentQuestion: number;
  score: number | null;
  metadata: JsonValue | null;
}

export interface CandidateQuestion {
  id: string;
  questionId: string;
  questionNumber: number;
  createdAt: Date;
  updatedAt: Date | null;
  deletedAt: Date | null;
  type: string;
}

export interface QuestionMcqOption {
  id: string;
  text: string;
  isCorrect: boolean;
  questionId: string;
  order: number;
}

export interface QuestionRankOption {
  id: string;
  text: string;
  correctRank: number;
  questionId: string;
  order: number;
  createdAt: Date;
}

export interface QuestionMcqAnswer {
  id: string;
  quizId: string;
  questionId: string;
  optionId: string;
  timeSpent: number;
  score: number | null;
  createdAt: Date;
}

export interface QuestionRankAnswer {
  id: string;
  quizId: string;
  questionId: string;
  timeSpent: number;
  score: number | null;
  createdAt: Date;
}

export interface QuestionRankOptionAnswer {
  id: string;
  answerId: string;
  optionId: string;
  givenRank: number;
}

export interface Tag {
  id: string;
  name: string;
  color: string;
  deletedAt: Date | null;
  teamId: string;
  createdAt: Date;
  updatedAt: Date | null;
}

export interface JobTag {
  id: string;
  createdAt: Date;
  updatedAt: Date | null;
  deletedAt: Date | null;
  jobId: string;
  tagId: string;
}

export interface LinkTag {
  id: string;
  createdAt: Date;
  updatedAt: Date | null;
  deletedAt: Date | null;
  linkId: string;
  tagId: string;
}

export interface ContentTemplates {
  template: string;
  version: number;
  templateType: string;
  name: string;
  teamId: string;
  userId: string;
  createdAt: Date;
  updatedAt: Date | null;
}

export interface JobEmailTemplate {
  id: string;
  jobId: string;
  name: string;
  subject: string;
  body: string;
  signature: string;
  useSignature: boolean;
  isDefault: boolean;
  createdAt: Date;
  updatedAt: Date | null;
  deletedAt: Date | null;
  createdBy: string;
}

export interface CandidateEmailOutreach {
  id: string;
  emailTemplateId: string | null;
  candidateId: string;
  jobId: string | null;
  userId: string;
  resendId: string | null;
  messageId: string | null;
  status: string;
  subject: string;
  body: string;
  sentAt: Date;
  openedAt: Date | null;
  clickedAt: Date | null;
  deliveredAt: Date | null;
  complainedAt: Date | null;
  createdAt: Date;
  updatedAt: Date | null;
}

export interface Token {
  id: string;
  name: string;
  hashedKey: string;
  partialKey: string;
  expires: Date | null;
  lastUsed: Date | null;
  createdAt: Date;
  updatedAt: Date | null;
  userId: string;
}

export interface ExtensionToken {
  identifier: string;
  token: string;
  expires: Date;
  userId: string;
  createdAt: Date;
  updatedAt: Date | null;
}

export interface RestrictedToken {
  id: string;
  name: string;
  hashedKey: string;
  partialKey: string;
  scopes: string | null;
  expires: Date | null;
  lastUsed: Date | null;
  rateLimit: number;
  createdAt: Date;
  updatedAt: Date | null;
  userId: string;
  teamId: string;
  installationId: string | null;
}

export interface VerificationToken {
  identifier: string;
  token: string;
  expires: Date;
}

export interface EmailVerificationToken {
  identifier: string;
  token: string;
  expires: Date;
}

export interface PasswordResetToken {
  identifier: string;
  token: string;
  expires: Date;
}

export interface UtmTemplate {
  id: string;
  name: string;
  utmSource: string | null;
  utmMedium: string | null;
  utmCampaign: string | null;
  utmTerm: string | null;
  utmContent: string | null;
  ref: string | null;
  userId: string | null;
  teamId: string | null;
  createdAt: Date;
  updatedAt: Date | null;
}

export interface Webhook {
  id: string;
  receiver: string;
  installationId: string | null;
  teamId: string;
  name: string;
  url: string;
  secret: string;
  triggers: JsonValue;
  consecutiveFailures: number;
  lastFailedAt: Date | null;
  disabledAt: Date | null;
  createdAt: Date;
  updatedAt: Date | null;
}

export interface LinkWebhook {
  linkId: string;
  webhookId: string;
}

export interface ProviderRequests {
  id: string;
  options: JsonValue | null;
}

export interface Providers {
  id: string;
}

export interface RefreshTokenTypes {
  value: string;
  comment: string | null;
}

export interface RefreshToken {
  id: string;
  createdAt: Date;
  expiresAt: Date;
  userId: string;
  metadata: JsonValue | null;
  type: string;
  refreshTokenHash: string | null;
}

export interface Role {
  id: string;
}

export interface Session {
  id: string;
  sessionToken: string;
  userId: string;
  expires: Date;
}

export interface UserProviders {
  id: string;
  createdAt: Date;
  updatedAt: Date;
  userId: string;
  accessToken: string;
  refreshTokenKey: string | null;
  providerId: string;
  providerUserId: string;
}

export interface AuthUserRoles {
  id: string;
  createdAt: Date;
  userId: string;
  role: string;
}

export interface UserSecurityKeys {
  id: string;
  userId: string;
  credentialId: string;
  credentialPublicKey: Buffer | null;
  counter: bigint;
  transports: string;
  nickname: string | null;
}

export interface Account {
  id: string;
  createdAt: Date;
  updatedAt: Date;
  lastSeen: Date | null;
  disabled: boolean;
  displayName: string;
  image: string;
  locale: string;
  email: string | null;
  phoneNumber: string | null;
  passwordHash: string | null;
  emailVerified: boolean;
  phoneNumberVerified: boolean;
  newEmail: string | null;
  otpMethodLastUsed: string | null;
  otpHash: string | null;
  otpHashExpiresAt: Date;
  defaultRole: string;
  isAnonymous: boolean;
  totpSecret: string | null;
  activeMfaType: string | null;
  ticket: string | null;
  ticketExpiresAt: Date;
  metadata: JsonValue | null;
  webauthnCurrentChallenge: string | null;
}

export interface Commission {
  id: string;
  programId: string;
  partnerId: string;
  linkId: string;
  payoutId: string | null;
  invoiceId: string | null;
  customerId: string | null;
  eventId: string | null;
  amount: number;
  quantity: number;
  earnings: number;
  currency: string;
  status: string;
  type: string;
  createdAt: Date;
  updatedAt: Date | null;
}

export interface Customer {
  id: string;
  name: string | null;
  email: string | null;
  avatar: string | null;
  externalId: string | null;
  stripeCustomerId: string | null;
  linkId: string | null;
  clickId: string | null;
  clickedAt: Date | null;
  country: string | null;
  teamId: string;
  teamConnectId: string | null;
  createdAt: Date;
  updatedAt: Date | null;
}

export interface Discount {
  id: string;
  amount: number;
  duration: number | null;
  maxDuration: number | null;
  couponId: string | null;
  couponTestId: string | null;
  teamId: string;
  programId: string;
  createdAt: Date;
  updatedAt: Date | null;
  type: string;
  interval: string | null;
}

export interface Domain {
  id: string;
  slug: string;
  verified: boolean;
  placeholder: string | null;
  expiredUrl: string | null;
  notFoundUrl: string | null;
  primary: boolean;
  archived: boolean;
  lastChecked: Date;
  appleAppSiteAssociation: JsonValue | null;
  assetLinks: JsonValue | null;
  logo: string | null;
  teamId: string | null;
  createdAt: Date;
  updatedAt: Date | null;
}

export interface RegisteredDomain {
  id: string;
  slug: string;
  createdAt: Date;
  updatedAt: Date | null;
  expiresAt: Date;
  teamId: string;
  domainId: string | null;
}

export interface DefaultDomains {
  id: string;
  pandaqzlink: boolean;
  hirepandalink: boolean;
  valleyhirepandacom: boolean;
  apply2joblink: boolean;
  applybetterlink: boolean;
  click2worklink: boolean;
  fastapplylink: boolean;
  hiredirectlink: boolean;
  instaapplylink: boolean;
  takeqzlink: boolean;
  apply2work: boolean;
  pandaquizme: boolean;
  pandatestme: boolean;
  pandaquizin: boolean;
  pandatestapp: boolean;
  pandatestin: boolean;
  applyherework: boolean;
  apply2jobcom: boolean;
  teamId: string;
}

export interface SubscriptionStatusEnum {
  value: string;
}

export interface WorkspacePlansEnum {
  value: string;
}

export interface PricingPlanIntervalEnum {
  value: string;
}

export interface PricingTypeEnum {
  value: string;
}

export interface UserRolesEnum {
  value: string;
}

export interface PayoutStatusEnum {
  value: string;
}

export interface PayoutTypeEnum {
  value: string;
}

export interface ProgramTypeEnum {
  value: string;
}

export interface CommissionTypeEnum {
  value: string;
}

export interface ProgramEnrollmentStatusEnum {
  value: string;
}

export interface CommissionIntervalEnum {
  value: string;
}

export interface PartnerStatusEnum {
  value: string;
}

export interface PartnerRoleEnum {
  value: string;
}

export interface InvoiceStatusEnum {
  value: string;
}

export interface CommissionStatusEnum {
  value: string;
}

export interface EventTypeEnum {
  value: string;
}

export interface PaymentProviderEnum {
  value: string;
}

export interface PartnerProfileTypeEnum {
  value: string;
}

export interface PayoutInvoice {
  id: string;
  teamId: string;
  number: string | null;
  programId: string;
  status: string;
  amount: number;
  fee: number;
  total: number;
  receiptUrl: string | null;
  createdAt: Date;
}

export interface SubscriptionInvoice {
  id: string;
  teamId: string;
  number: string | null;
  subscriptionId: string;
  status: string;
  amount: number;
  fee: number;
  total: number;
  receiptUrl: string | null;
  createdAt: Date;
  providerType: string | null;
  providerInvoiceId: string | null;
  currency: string;
  metadata: JsonValue | null;
}

export interface JacksonIndex {
  id: number;
  key: string;
  storeKey: string;
}

export interface JacksonStore {
  key: string;
  value: string;
  iv: string | null;
  tag: string | null;
  namespace: string | null;
  createdAt: Date;
  modifiedAt: Date | null;
}

export interface JacksonTtl {
  key: string;
  expiresAt: bigint;
}

export interface Partner {
  id: string;
  name: string;
  companyName: string | null;
  profileType: string;
  email: string | null;
  image: string | null;
  description: string | null;
  country: string;
  status: string;
  stripeConnectId: string | null;
  payoutsEnabled: boolean;
  createdAt: Date;
  updatedAt: Date | null;
  showOnLeaderboard: boolean;
  payoutsEnabledAt: Date | null;
  website: string | null;
  websiteTxtRecord: string | null;
  websiteVerifiedAt: Date | null;
  youtube: string | null;
  youtubeVerifiedAt: Date | null;
  twitter: string | null;
  twitterVerifiedAt: Date | null;
  linkedin: string | null;
  linkedinVerifiedAt: Date | null;
  instagram: string | null;
  instagramVerifiedAt: Date | null;
}

export interface PartnerUser {
  id: string;
  role: string;
  userId: string;
  partnerId: string;
  createdAt: Date;
  updatedAt: Date | null;
}

export interface PartnerInvite {
  email: string;
  expires: Date;
  partnerId: string;
  role: string;
  createdAt: Date;
}

export interface Payout {
  id: string;
  programId: string;
  partnerId: string;
  invoiceId: string | null;
  amount: number;
  currency: string;
  status: string;
  type: string;
  description: string | null;
  periodStart: Date | null;
  periodEnd: Date | null;
  quantity: number | null;
  stripeTransferId: string | null;
  createdAt: Date;
  updatedAt: Date | null;
  paidAt: Date | null;
}

export interface Price {
  id: string;
  productId: string;
  active: boolean | null;
  description: string | null;
  unitAmount: bigint | null;
  currency: string | null;
  type: string;
  interval: string | null;
  intervalCount: number | null;
  trialPeriodDays: number | null;
  metadata: JsonValue | null;
  clicks: number | null;
  links: number | null;
  ai: number | null;
  api: number | null;
  folders: number | null;
  jobs: number | null;
  tags: number | null;
  users: number | null;
  sales: number | null;
  candidates: number | null;
}

export interface Product {
  id: string;
  active: boolean | null;
  name: string;
  description: string | null;
  image: string | null;
  metadata: JsonValue | null;
}

export interface Program {
  id: string;
  teamId: string;
  name: string;
  slug: string;
  logo: string | null;
  wordmark: string | null;
  brandColor: string | null;
  domain: string | null;
  url: string | null;
  type: string;
  cookieLength: number;
  defaultRewardId: string | null;
  defaultFolderId: string | null;
  defaultDiscountId: string | null;
  holdingPeriodDays: number;
  minPayoutAmount: number;
  landerData: JsonValue | null;
  resources: JsonValue | null;
  termsUrl: string | null;
  ageVerification: number | null;
  createdAt: Date;
  updatedAt: Date | null;
}

export interface ProgramEnrollment {
  id: string;
  partnerId: string;
  programId: string;
  tenantId: string | null;
  applicationId: string | null;
  commissionAmount: number | null;
  discountId: string | null;
  status: string;
  createdAt: Date;
  updatedAt: Date | null;
}

export interface ProgramApplication {
  id: string;
  programId: string;
  partnerId: string | null;
  name: string;
  email: string;
  proposal: string | null;
  website: string | null;
  comments: string | null;
  createdAt: Date;
  updatedAt: Date | null;
}

export interface Reward {
  id: string;
  programId: string;
  name: string | null;
  event: string;
  type: string;
  amount: number;
  maxDuration: number | null;
  createdAt: Date;
  updatedAt: Date | null;
}

export interface PartnerReward {
  id: string;
  programEnrollmentId: string;
  rewardId: string;
  createdAt: Date;
  updatedAt: Date | null;
}

export interface Subscription {
  id: string;
  status: string | null;
  metadata: JsonValue | null;
  priceId: string;
  quantity: number | null;
  cancelAtPeriodEnd: boolean | null;
  created: Date;
  currentPeriodStart: Date;
  currentPeriodEnd: Date;
  endedAt: Date | null;
  cancelAt: Date | null;
  cancelledAt: Date | null;
  trialStart: Date | null;
  trialEnd: Date | null;
  providerType: string | null;
  providerSubscriptionId: string | null;
}

export interface User {
  id: string;
  email: string | null;
  isDeleted: boolean;
  isActive: boolean;
  isMachine: boolean;
  defaultTeam: string | null;
  defaultPartnerId: string | null;
  createdAt: Date;
  updatedAt: Date | null;
  invalidLoginAttempts: number;
  lockedAt: Date | null;
  source: string | null;
  saasPartnerId: string | null;
  passwordHash: string | null;
  emailVerified: Date | null;
  image: string | null;
  name: string | null;
  provider: string | null;
  subscribed: boolean;
}

export interface UserAccounts {
  userId: string;
  accountId: string | null;
  loginAccountId: string | null;
}

export interface UserLoginAccount {
  id: string;
  userId: string;
  type: string;
  provider: string;
  providerAccountId: string;
  refreshToken: string | null;
  refreshTokenExpiresIn: number | null;
  accessToken: string | null;
  expiresAt: number | null;
  tokenType: string | null;
  scope: string | null;
  idToken: string | null;
  sessionState: string | null;
}

export interface TeamInvite {
  teamId: string;
  email: string;
  expires: Date;
  createdAt: Date;
  updatedAt: Date | null;
  deletedAt: Date | null;
  role: string;
}

export interface TeamMember {
  id: string;
  teamId: string;
  userId: string;
  joinedAt: Date;
  role: string;
  createdAt: Date;
  updatedAt: Date | null;
  deletedAt: Date | null;
}

export interface TeamSettings {
  id: string;
  teamId: string;
  settingKey: string;
  settingValue: string;
  settingStatus: boolean;
  createdAt: Date;
  updatedAt: Date | null;
  deletedAt: Date | null;
}

export interface NotificationPreference {
  id: string;
  teamMemberId: string;
  values: JsonValue;
}

export interface Team {
  id: string;
  name: string;
  subscriptionId: string | null;
  slug: string;
  logo: string | null;
  inviteCode: string | null;
  plan: string;
  stripeId: string | null;
  billingCycleStart: number;
  paymentFailedAt: Date | null;
  stripeConnectId: string | null;
  payoutMethodId: string | null;
  invoicePrefix: string | null;
  totalLinks: number;
  totalJobs: number;
  totalClicks: number;
  usage: number;
  usageLimit: number;
  linksUsage: number;
  linksLimit: number;
  salesUsage: number;
  salesLimit: number;
  domainsLimit: number;
  tagsLimit: number;
  usersLimit: number;
  aiUsage: number;
  aiLimit: number;
  jobsUsage: number;
  jobsLimit: number;
  foldersUsage: number;
  foldersLimit: number;
  candidatesUsage: number;
  candidatesLimit: number;
  collaboratorsUsage: number;
  collaboratorsLimit: number;
  store: JsonValue | null;
  allowedHostnames: JsonValue | null;
  paymentProvider: string | null;
  stripeCustomerId: string | null;
  chargebeeCustomerId: string | null;
  razorpayCustomerId: string | null;
  defaultCurrency: string;
  companyName: string | null;
  companyUrl: string | null;
  referralLinkId: string | null;
  referredSignups: number;
  webhookEnabled: boolean;
  partnersEnabled: boolean;
  ssoEnabled: boolean;
  conversionEnabled: boolean;
  dotLinkClaimed: boolean;
  createdAt: Date;
  updatedAt: Date | null;
  usageLastChecked: Date;
}

export interface Buckets {
  id: string;
  createdAt: Date;
  updatedAt: Date;
  downloadExpiration: number;
  minUploadFileSize: number;
  maxUploadFileSize: number;
  cacheControl: string | null;
  presignedUrlsEnabled: boolean;
}

export interface Files {
  id: string;
  createdAt: Date;
  updatedAt: Date;
  bucketId: string;
  name: string | null;
  size: number | null;
  mimeType: string | null;
  etag: string | null;
  isUploaded: boolean | null;
  uploadedByUserId: string | null;
  metadata: JsonValue | null;
}

export interface Virus {
  id: string;
  createdAt: Date;
  updatedAt: Date | null;
  fileId: string;
  filename: string;
  virus: string;
  userSession: JsonValue;
}

type JsonValue = string | number | boolean | { [key in string]?: JsonValue } | Array<JsonValue> | null;
